// extracted by mini-css-extract-plugin
module.exports = {"container":"label-item_container__2cbsk","label":"label-item_label__3DSYu compLabel","item":"label-item_item__Mw-gM","labelItem":"label-item_labelItem__1tE5m"};